(function () {
  if (window.__tstInit) return;
  window.__tstInit = true;

  var ARROW_LEFT = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  var ARROW_RIGHT = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  var BADGE_ICON = '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M10 0l2.4 2.1 3.2-.2 1 3 2.7 1.7-.9 3.1.9 3.1-2.7 1.7-1 3-3.2-.2L10 20l-2.4-2.1-3.2.2-1-3-2.7-1.7.9-3.1-.9-3.1 2.7-1.7 1-3 3.2.2L10 0zm-1.2 13.4l5-5-1.2-1.2-3.8 3.8-1.8-1.8-1.2 1.2 3 3z"/></svg>';

  function esc(value) {
    var node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function fetchIndex(base) {
    return window.tstBoot.index(base);
  }

  function hash(text) {
    var value = 0;
    text = String(text);
    for (var i = 0; i < text.length; i++) value = (value * 31 + text.charCodeAt(i)) | 0;
    value ^= value >>> 16;
    value = Math.imul(value, 0x85ebca6b);
    value ^= value >>> 13;
    value = Math.imul(value, 0xc2b2ae35);
    value ^= value >>> 16;
    return value;
  }

  function sortItems(items, order) {
    return items.slice().sort(function (a, b) {
      if (order === 'highest' || order === 'lowest') {
        var byRating = (parseFloat(b.r) || 0) - (parseFloat(a.r) || 0);
        if (order === 'lowest') byRating = -byRating;
        if (byRating) return byRating;
      }
      var dateA = a.d || '';
      var dateB = b.d || '';
      if (dateA !== dateB) {
        if (!dateA) return 1;
        if (!dateB) return -1;
        return order === 'oldest' ? (dateA < dateB ? -1 : 1) : (dateA < dateB ? 1 : -1);
      }
      return hash(a.h) - hash(b.h);
    });
  }

  function setupList(root) {
    if (root.__tstReady) return;
    root.__tstReady = true;

    var src = root.getAttribute('data-tst-src');
    var pickUrl = root.getAttribute('data-tst-pick');
    var mode = root.getAttribute('data-tst-mode');
    var perPage = parseInt(root.getAttribute('data-tst-per-page'), 10) || 10;
    var order = root.getAttribute('data-tst-sort') || 'newest';
    var badge = root.getAttribute('data-tst-badge') || '';
    var moreLabel = root.getAttribute('data-tst-more-label') || 'Load more';
    var list = root.querySelector('[data-tst-list]');
    var controls = root.querySelector('[data-tst-controls]');
    var countNumber = root.querySelector('.tst-count-number');
    var toolbar = root.querySelector('[data-tst-toolbar]');
    var showingText = root.querySelector('[data-tst-showing]');
    var sortSelect = root.querySelector('[data-tst-sort-select]');
    var allItems = [];
    var items = [];
    var html = window.tstBoot.getHtml();
    var shown = 0;
    var currentPage = 1;
    var observer = null;
    var busy = false;
    var token = 0;

    function loadCards(slice) {
      var missing = slice.filter(function (item) { return !(item.h in html); }).map(function (item) { return item.h; });
      if (!missing.length) return Promise.resolve();
      return fetch(pickUrl + encodeURIComponent(missing.join(',')), { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var data = JSON.parse(text);
          (data.items || []).forEach(function (entry) { html[entry.h] = entry.html; });
          window.tstBoot.saveHtml(html);
        })
        .catch(function () {});
    }

    function buildCard(item) {
      var markup = html[item.h];
      if (!markup) return null;
      var holder = document.createElement('template');
      holder.innerHTML = markup;
      var card = holder.content.firstElementChild;
      if (card && badge) {
        var person = card.querySelector('.tst-person');
        if (person && !person.querySelector('.tst-badge')) {
          var tag = document.createElement('span');
          tag.className = 'tst-badge';
          tag.innerHTML = BADGE_ICON + ' ' + esc(badge);
          person.appendChild(tag);
        }
      }
      return card;
    }

    function render(slice, replace) {
      if (replace) list.innerHTML = '';
      slice.forEach(function (item) {
        var card = buildCard(item);
        if (card) list.appendChild(card);
      });
    }

    function prefetch(from) {
      var slice = items.slice(from, from + perPage);
      if (slice.length) loadCards(slice);
    }

    function updateShowing(from, to) {
      if (!showingText) return;
      showingText.textContent = 'Showing ' + from + '\u2013' + to + ' of ' + items.length + ' results';
    }

    function pageCount() {
      return Math.max(1, Math.ceil(items.length / perPage));
    }

    function renderNav() {
      var total = pageCount();
      if (total < 2) { controls.innerHTML = ''; return; }
      var out = '<nav class="tst-pager" role="navigation" aria-label="Pagination">';
      out += currentPage > 1
        ? '<a href="?page=' + (currentPage - 1) + '" class="tst-pager-btn" data-tst-page="' + (currentPage - 1) + '" aria-label="Previous page">' + ARROW_LEFT + '<span>Previous</span></a>'
        : '<span class="tst-pager-btn" aria-disabled="true">' + ARROW_LEFT + '<span>Previous</span></span>';
      out += '<ul class="tst-pager-list">';
      for (var number = 1; number <= total; number++) {
        var near = number === 1 || number === total || Math.abs(number - currentPage) <= 1;
        if (!near) {
          if (number === 2 || number === total - 1) out += '<li class="tst-pager-gap">&hellip;</li>';
          continue;
        }
        out += number === currentPage
          ? '<li><span class="tst-pager-num is-active" aria-current="page">' + number + '</span></li>'
          : '<li><a href="?page=' + number + '" class="tst-pager-num" data-tst-page="' + number + '" aria-label="Page ' + number + '">' + number + '</a></li>';
      }
      out += '</ul>';
      out += currentPage < total
        ? '<a href="?page=' + (currentPage + 1) + '" class="tst-pager-btn" data-tst-page="' + (currentPage + 1) + '" aria-label="Next page"><span>Next</span>' + ARROW_RIGHT + '</a>'
        : '<span class="tst-pager-btn" aria-disabled="true"><span>Next</span>' + ARROW_RIGHT + '</span>';
      out += '<p class="tst-pager-status">Page ' + currentPage + ' of ' + total + '</p></nav>';
      controls.innerHTML = out;
    }

    function showPage(number, scroll) {
      var mine = ++token;
      currentPage = Math.min(Math.max(1, number), pageCount());
      var slice = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      list.classList.add('is-busy');
      loadCards(slice).then(function () {
        if (mine !== token) return;
        render(slice, true);
        list.classList.remove('is-busy');
        updateShowing((currentPage - 1) * perPage + 1, Math.min(items.length, currentPage * perPage));
        renderNav();
        prefetch(currentPage * perPage);
        try {
          var url = new URL(window.location.href);
          if (currentPage > 1) { url.searchParams.set('page', currentPage); } else { url.searchParams.delete('page'); }
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}
        if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function drawMoreControls() {
      if (observer) { observer.disconnect(); observer = null; }
      if (shown >= items.length) {
        controls.innerHTML = '';
        return;
      }
      if (mode === 'infinite') {
        controls.innerHTML = '<div class="tst-sentinel" data-tst-sentinel></div>';
        var sentinel = controls.querySelector('[data-tst-sentinel]');
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) appendMore();
          }, { rootMargin: '400px 0px' });
          observer.observe(sentinel);
        }
      } else {
        controls.innerHTML =
          '<div class="tst-more-wrap"><button type="button" class="btn btn-outline-primary" data-tst-more>' + esc(moreLabel) + '</button></div>';
      }
    }

    function appendMore() {
      if (busy || shown >= items.length) return;
      busy = true;
      var slice = items.slice(shown, shown + perPage);
      loadCards(slice).then(function () {
        render(slice, false);
        shown = Math.min(items.length, shown + perPage);
        updateShowing(1, shown);
        busy = false;
        drawMoreControls();
        prefetch(shown);
      });
    }

    controls.addEventListener('click', function (event) {
      var pageLink = event.target.closest('[data-tst-page]');
      if (pageLink) {
        event.preventDefault();
        showPage(parseInt(pageLink.getAttribute('data-tst-page'), 10), true);
        return;
      }
      if (event.target.closest('[data-tst-more]')) appendMore();
    });

    function start() {
      if (mode === 'pagination') {
        var requested = 1;
        try { requested = parseInt(new URL(window.location.href).searchParams.get('page'), 10) || 1; } catch (e) {}
        list.classList.remove('is-loading');
        showPage(requested, false);
      } else {
        var first = items.slice(0, perPage);
        loadCards(first).then(function () {
          list.classList.remove('is-loading');
          list.innerHTML = '';
          shown = 0;
          render(first, false);
          shown = first.length;
          updateShowing(1, shown);
          drawMoreControls();
          prefetch(shown);
        });
      }
    }

    if (sortSelect) {
      sortSelect.value = order;
      sortSelect.addEventListener('change', function () {
        order = sortSelect.value;
        items = sortItems(allItems, order);
        token++;
        busy = false;
        if (mode === 'pagination') {
          showPage(1, false);
        } else {
          start();
        }
      });
    }

    fetchIndex(src).then(function (all) {
      allItems = all;
      items = sortItems(all, order);

      if (!items.length) {
        list.classList.remove('is-loading');
        list.innerHTML = '<p class="tst-empty" style="grid-column: 1 / -1;">No testimonials yet.</p>';
        return;
      }

      if (countNumber) countNumber.textContent = items.length;
      if (toolbar) toolbar.hidden = false;
      start();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tst-root]').forEach(setupList);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-tst-embed]');
    if (!trigger) return;
    var frame = document.createElement('iframe');
    frame.src = trigger.getAttribute('data-tst-embed');
    frame.allow = 'autoplay; fullscreen; picture-in-picture';
    frame.setAttribute('allowfullscreen', '');
    frame.title = trigger.getAttribute('aria-label') || 'Video testimonial';
    trigger.replaceWith(frame);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
